import { logWrapper } from '../../utils';
import CryptoJS from 'crypto-js';
import { resolveReferences } from '../../utils';

export default {
  authService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    '$rootScope',
    'localStorageService',
    'webApiSettings',
    'PermRoleStore',
    'PermPermissionStore',
    'EAdminFeatures',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      $rootScope,
      localStorageService,
      webApiSettings,
      PermRoleStore,
      PermPermissionStore,
      EAdminFeatures
    ) {
      'use strict';

      let permissions = [];
      let authServiceFactory = {};

      var userPromise = null;

      var user = {
        email: '',
      };

      var authentication = {
        isAuth: false,
        email: '',
        token: '',
        isExternalLogin: false,
      };

      function isSysAdmin() {
        return user.isSysAdmin === true;
      }

      function isAdmin() {
        if (isSysAdmin()) return true;

        try {
          var loggedCompany = getLoggedCompany();
          var isAdmin;
          if (loggedCompany !== null) {
            isAdmin = loggedCompany.IsAdmin;
            return isAdmin;
          }
        } catch {}
      }

      function createPermissions() {
        permissions[EAdminFeatures.ConfigureDigitalization] =
          'ConfigDigitalization';
        permissions[EAdminFeatures.ConfigureSystemOptions] =
          'ConfigSystemOptions';
        permissions[EAdminFeatures.ManageExtensions] = 'ManageFileExtensions';
        permissions[EAdminFeatures.ManageGroups] = 'ManageGroups';
        permissions[EAdminFeatures.ManageUsers] = 'ManageUsers';
        permissions[EAdminFeatures.ManageRoles] = 'ManageRoles';
        permissions[EAdminFeatures.ManagePhysicalLocalizations] =
          'ManagePhysicalLocalizations';
        permissions[EAdminFeatures.ManageRepositories] = 'ManageRepositories';
        permissions[EAdminFeatures.ManageMediaTypes] = 'ManageMediaTypes';
        permissions[EAdminFeatures.ManageDocumentTypes] = 'ManageDocumentTypes';
        permissions[EAdminFeatures.ManageWorkflows] = 'ManageWorkflows';
        permissions[EAdminFeatures.ManageDataLists] = 'ManageDataLists';
        permissions[EAdminFeatures.ManageAdditionalFields] =
          'ManageAdditionalFields';
        permissions[EAdminFeatures.ViewReports] = 'ViewReports';
        permissions[EAdminFeatures.RegisterSystem] = 'RegisterSystem';
        permissions[EAdminFeatures.ManageTrashCan] = 'ManageTrashCan';
        permissions[EAdminFeatures.ManageFolders] = 'ManageFolders';
        permissions[EAdminFeatures.ExportMedia] = 'ExportMedia';
        permissions[EAdminFeatures.ManageNFes] = 'ManageNFes';
        permissions[EAdminFeatures.AutoComplete] = 'AutoComplete';
        permissions[EAdminFeatures.CanD4Sign] = 'CanD4Sign';
        permissions[EAdminFeatures.CanCertificata] = 'CanCertificata';
        permissions[EAdminFeatures.SharedFolder] = 'SharedFolder';
        permissions[EAdminFeatures.OnlyCreateFolder] = 'OnlyCreateFolder';
        permissions[EAdminFeatures.ManageExpire] = 'ManageExpire';
      }

      function definePermissions() {
        var adminFeatures = ($rootScope.user && $rootScope.user.adminFeatures || [])
          .map(x => x.IdAdminFeature);

        var _isAdmin = isAdmin();
        var _isSysAdmin = isSysAdmin();

        PermRoleStore.clearStore();
        PermPermissionStore.clearStore();

        if (_isAdmin || _isSysAdmin) {
          if (_isSysAdmin) {
            PermPermissionStore.definePermission('ManageCompanies', () => true);
          }
          if (_isSysAdmin) {
            PermPermissionStore.definePermission('ManageExpire', () => true);
          }

          PermPermissionStore.definePermission('ManageWorkflows', () => {
            var loggedCompany = getLoggedCompany();
            return loggedCompany && loggedCompany.Company.CanWorkflow === true;
          });

          PermPermissionStore.definePermission('ManageD4Sign', () => true);
          PermRoleStore.defineRole('ADMIN', () => true);
        } else if (adminFeatures) {
          for (
            var cont = 0, length = adminFeatures.length;
            cont < length;
            cont++
          ) {
            var admFeature = adminFeatures[cont];
            if (admFeature) {
              if (permissions[admFeature] !== undefined) {
                PermPermissionStore.definePermission(
                  permissions[admFeature].toString(),
                  () => true
                );
              }
            }
          }
        }

        PermRoleStore.defineRole('ROLE_WORKFLOW', [
          'WORKFLOW',
          'ManageWorkflows',
        ]);
        PermRoleStore.defineRole('MANAGE_EXPIRE', [
          'MANAGE_EXPIRE',
          'ManageExpire',
        ]);
      }

      function login(loginData, alreadyCripted) {
        var password = '';

        password = alreadyCripted
          ? loginData.password
          : CryptoJS.MD5(loginData.password).toString();

        var deferred = $q.defer();

        deferred.notify('Verificando email e senha');

        $http
          .post(webApiSettings.apiServiceBaseUri + 'api/login', {
            Email: loginData.email,
            Password: password,
          })
          .then((response) => {
            var payload = decodeToken(response.data.AccessToken);
            deferred.notify('Salvando sessão');

            localStorageService.set(
              'isAdmin',
              payload.IsCompanyAdmin === 'True'
            );
            localStorageService.set(
              'isSysAdmin',
              payload.IsSysAdmin === 'True'
            );

            definePermissions();
            defineModules();

            if (loginData.rememberMe) {
              localStorageService.set('refreshToken', {
                token: response.data.refresh_token,
              });
            }
            document.cookie =
              'authorizationData=' +
              response.data.AccessToken +
              ';Domain=.digitaldoc.com.br';

            localStorageService.set('authorizationData', {
              token: response.data.AccessToken,
              userName: loginData.email,
            });

            localStorageService.set('lastLoginEmail', loginData.email);

            authentication.isAuth = true;
            authentication.email = loginData.email;
            authentication.token = response.data.AccessToken;

            deferred.resolve(response);
          })
          .catch((err) => {
            logOut();
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function autoLogin(code) {
        var deferred = $q.defer();

        deferred.notify('Verificando email e senha');

        $http
          .get(`${webApiSettings.apiServiceBaseUri}api/login/${code}`)
          .then((response) => {
            var payload = decodeToken(response.data.AccessToken);
            deferred.notify('Salvando sessão');

            localStorageService.set(
              'isAdmin',
              payload.IsCompanyAdmin === 'True'
            );
            localStorageService.set(
              'isSysAdmin',
              payload.IsSysAdmin === 'True'
            );

            localStorageService.set('authorizationData', {
              token: response.data.AccessToken,
              userName: 'autologin',
            });

            authentication.isAuth = true;
            authentication.email = 'autologin';
            authentication.token = response.data.AccessToken;

            deferred.resolve(response);
          })
          .catch((err) => {
            logOut();
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function logOut() {
        localStorageService.remove('authorizationData');

        $rootScope.canSendFiles = false;
        authentication.isAuth = false;
        authentication.token = '';
        authentication.email = '';
        authentication.isExternalLogin = false;
        PermRoleStore.clearStore();
        PermPermissionStore.clearStore();
      }

      function switchCompany(idCompany) {
        var deferred = $q.defer();

        var preferences = user.userPreferences;
        var current = preferences.IdLastCompany;

        preferences.IdLastCompany = idCompany;

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'users/updatePreferences',
            preferences
          )
          .then(() => {
            authentication.isAuth = false;
            authentication.token = '';

            $http
              .post(webApiSettings.apiServiceBaseUri + 'api/login', {
                Email: user.email,
                Password: user.pass,
              })
              .then((res) => {
                var response = res.data;
                if (localStorageService.get('authorizationData')) {
                  localStorageService.set('authorizationData', {
                    token: response.AccessToken,
                    userName: user.email,
                  });
                }

                authentication.isAuth = true;
                authentication.token = response.AccessToken;

                deferred.resolve(true);
              })
              .catch((err) => {
                var error = handleError(err.data, err.status);
                deferred.reject(error);
              });
          })
          .catch((err) => {
            preferences.IdLastCompany = current;
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getCompanyLogo(idCompany) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'companies/' +
              idCompany +
              '/logo',
            {
              responseType: 'arraybuffer',
            }
          )
          .then((result) => {
            var data = result.data;
            if (data) {
              var byteArray = new Uint8Array(data);
              var base64String = btoa(
                String.fromCharCode.apply(null, byteArray)
              );

              deferred.resolve(base64String);
            }
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function loadUser() {
        if (userPromise) {
          return userPromise;
        }

        var deferred = $q.defer();
        userPromise = deferred.promise;

        $http
          .get(webApiSettings.apiServiceBaseUri + 'users/current')
          .then((data) => {
            var u = resolveReferences(data.data);

            // garante objeto
            user = user || {};

            user.adminFeatures = u.AdminFeatures;
            user.authenticationType = 'Password';
            user.companies = u.Companies;
            user.email = u.Email;
            user.id = u.Id;
            user.idPreference = u.IdPreference;
            user.isAuthenticated = true;
            user.isSysAdmin = u.IsSysAdmin;
            user.name = u.Name;
            user.pass = u.Pass;
            user.phone = u.Phone;

            // 🔐 BLINDAGEM CRÍTICA
            user.userPreferences = u.Preferences || {};

            user.changePass = u.ChangePass;
            user.idFolderIntegration = u.IdFolderIntegration;
            user.logo = u.Logo;
            user.cpf = u.Cpf;
            user.certificataTokenApi = u.CertificataTokenApi;
            user.isTempUser = u.IsTempUser;

            if (u.D4SignTokenApi) {
              user.D4SignTokenApi = u.D4SignTokenApi;
              user.D4SignCriptKey = u.D4SignCriptKey;
            }

            $rootScope.user = user;

            $rootScope.$broadcast('USER_LOADED');

            definePermissions();
            defineModules();

            deferred.resolve(user);
          })
          .catch((err) => {
            userPromise = null;
            deferred.reject(err.data);
          });

        return deferred.promise;
      }

      function getUserAsync() {
        return user && user.isAuthenticated
          ? $q.resolve(user)
          : loadUser();
      }

      function fillAuthData() {
        var authData = localStorageService.get('authorizationData');
        if (authData) {
          authentication.isAuth = true;
          authentication.email = authData.userName;
          authentication.token = authData.token;
        }
      }

      function getLastLoginEmail() {
        var email = localStorageService.get('lastLoginEmail');

        if (email) return email;
        return '';
      }

      function verifyHasAdminFeature(lstFeatures) {
        if (authServiceFactory.user && authServiceFactory.user.email !== '') {
          if (authServiceFactory.authentication.email === 'autologin')
            return false;
          if (authServiceFactory.isAdmin()) return true;

          var anyAdminFeature =
            authServiceFactory.user.adminFeatures &&
            authServiceFactory.user.adminFeatures.some(
              (af) => lstFeatures.indexOf(af.IdAdminFeature) > -1
            );
          return anyAdminFeature;
        }
        return false;
      }

      function urlBase64Decode(str) {
        var output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
          case 0: {
            break;
          }
          case 2: {
            output += '==';
            break;
          }
          case 3: {
            output += '=';
            break;
          }
          default: {
            throw 'Illegal base64url string!';
          }
        }
        return decodeURIComponent(escape(atob(output)));
      }

      function decodeToken(token) {
        var parts = token.split('.');

        if (parts.length !== 3) throw new Error('JWT must have 3 parts');
        var decoded = urlBase64Decode(parts[1]);
        if (!decoded) throw new Error('Cannot decode the token');

        return angular.fromJson(decoded);
      }

      function getTokenExpirationDate(token) {
        var decoded = decodeToken(token);
        if (typeof decoded.exp === 'undefined') return null;

        var d = new Date(0);
        d.setUTCSeconds(decoded.exp);
        return d;
      }

      function storeAuthData() {
        localStorageService.set('authorizationData', {
          token: authentication.token,
          userName: authentication.email,
        });
      }

      function forgotPassword(email) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              `api/login/forgot-my-password/${email}`
          )
          .then(() => {
            deferred.resolve(true);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function recoverPassword(password, token) {
        var deferred = $q.defer();

        localStorageService.set('authorizationData', {
          token: token,
          userName: 'recoverPass',
        });

        authentication.isAuth = true;
        authentication.email = 'recoverPass';
        authentication.token = token;

        $http
          .put(
            webApiSettings.apiServiceBaseUri +
              'users/change-pass-by-forgot-password',
            {
              newPass: CryptoJS.MD5(password).toString(),
            }
          )
          .then(() => {
            logOut();
            deferred.resolve(true);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function userLogs() {
        var deferred = $q.defer();
        $http
          .post(`${webApiSettings.apiServiceBaseUri}users/wiki`)
          .then(function (result) {
            deferred.resolve(result);
          })
          .catch((err) => {
            deferred.reject(handleError(err.data, err.status));
          });

        return deferred.promise;
      }

      function handleError(err, status) {
        if (status === 404) {
          var error = {
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }
        if (status === 402) {
          var error = {
            error: $filter('translate')('UNAUTHORIZED'),
            error_description: $filter('translate')('LOGIN AT THE WRONG TIME'),
          };
          return error;
        }
        if (status === 401) {
          var error = {
            error: $filter('translate')('UNAUTHORIZED'),
            error_description: $filter('translate')('UNAUTHORIZED MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== '' && err !== undefined
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getLoggedCompany() {
        if (user && user.userPreferences) {
          var idCompany = user.userPreferences.IdLastCompany;
          var companies = user.companies.filter(
            (c) => c.IdCompany === idCompany
          );
          return companies[0];
        }
        return null;
      }

      function defineModules() {
        var loggedCompany = getLoggedCompany();

        if (loggedCompany) {
          PermPermissionStore.definePermission(
            'WORKFLOW',
            () => !!loggedCompany.Company.CanWorkflow
          );
          PermPermissionStore.definePermission(
            'DIGITAL_SIGNATURE',
            () => !!loggedCompany.Company.CanSignFiles
          );
          PermPermissionStore.definePermission(
            'EXPORT_MEDIA',
            () => !!loggedCompany.Company.CanExportMedia
          );
          PermPermissionStore.definePermission(
            'ENABLE_NFE',
            () => !!loggedCompany.Company.CanNfe
          );
          PermPermissionStore.definePermission(
            'CanD4Sign',
            () => !!loggedCompany.Company.CanD4Sign
          );
          PermPermissionStore.definePermission(
            'CanCertificata',
            () => !!loggedCompany.Company.CanCertificata
          );
        }
      }

      function onStateChangePermissionStart() {
        if (!PermPermissionStore.getStore() && !PermRoleStore.getStore()) {
          definePermissions();
        }
      }

      function run() {
        try {
          $rootScope.$on(
            '$stateChangePermissionStart',
            onStateChangePermissionStart
          );

          createPermissions();

          authServiceFactory.user = user;
          authServiceFactory.authentication = authentication;
          authServiceFactory.login = logWrapper(
            login,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.autoLogin = logWrapper(
            autoLogin,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.logOut = logWrapper(
            logOut,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.switchCompany = logWrapper(
            switchCompany,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.getCompanyLogo = logWrapper(
            getCompanyLogo,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.loadUser = logWrapper(
            loadUser,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.getUserAsync = logWrapper(
            getUserAsync,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.fillAuthData = logWrapper(
            fillAuthData,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.getLastLoginEmail = logWrapper(
            getLastLoginEmail,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.isAdmin = logWrapper(
            isAdmin,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.verifyHasAdminFeature = logWrapper(
            verifyHasAdminFeature,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.isSysAdmin = logWrapper(
            isSysAdmin,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.storeAuthData = logWrapper(
            storeAuthData,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.getLoggedCompany = logWrapper(
            getLoggedCompany,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.forgotPassword = logWrapper(
            forgotPassword,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.getTokenExpirationDate = logWrapper(
            getTokenExpirationDate,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.recoverPassword = logWrapper(
            recoverPassword,
            runtimeConstant.isDebugServicesInternals
          );
          authServiceFactory.userLogs = logWrapper(
            userLogs,
            runtimeConstant.isDebugServicesInternals
          );

          return authServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
